/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * Contact: redjar.redelivery@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ItemPostBody { 
    cdStore: number;
    cdItemsCategory: number;
    dsName: string;
    dsDescription: string;
    dsImg?: string;
    itemImage: Blob;
    qtSmallPrice?: number;
    qtMediumPrice: number;
    qtLargePrice?: number;
    nmSortNo?: number;
    isNonveg?: boolean;
    dsSmallText?: string;
    dsMediumText?: string;
    dsLargeText?: string;
    dsImageCode?: string;
    isActive?: boolean;
    isBanner: boolean;
}